import { render, staticRenderFns } from "./album-list.vue?vue&type=template&id=0f118dc6&scoped=true"
import script from "./album-list.vue?vue&type=script&lang=js"
export * from "./album-list.vue?vue&type=script&lang=js"
import style0 from "./album-list.vue?vue&type=style&index=0&id=0f118dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f118dc6",
  null
  
)

export default component.exports